import { RequestsKanbanBoardReducers } from './containers/RequestsKanbanBoard';
import { RequestStatisticBlockReducers } from './containers/RequestStatisticBlock';

export const RequestsPageReducers = {
  ...RequestsKanbanBoardReducers,
  ...RequestStatisticBlockReducers,
};
export default from './RequestsPageContainer';
